// extracted by mini-css-extract-plugin
module.exports = {"leaveBtn":"leaveBtn___1p5G4","icon":"icon___2mTS9","red":"red___FdE5i"};